import { useMemo } from "react";
import {
  ShowMessageDialog,
  ShowMessageDialogProps,
} from "@app/components/ShowMessageDialog";
import { useDialog } from "./useDialog";

export type ShowMessageParams = Omit<
  ShowMessageDialogProps,
  "onApply" | "onCancel"
>;

export const useShowMessage = () => {
  const dialog = useDialog();

  return useMemo(
    () => async (params: ShowMessageParams) =>
      dialog(ShowMessageDialog, params),
    [dialog],
  );
};
